import image1 from "../assets/t-image1.png";
import image2 from "../assets/t-image2.jpg";
import image3 from "../assets/t-image3.jpg";

export const testimonialsData = [
  {
    image: image1,
    review:
      "Joining FitClub was the best decision! The trainers and programs helped me achieve my dream body in no time.",
    name: 'MATHEW HENDRICKSON',
    status : 'ENTREPRENEUR'
  },
  {
    image: image2,
    review: 'The training programs here are top-notch! I have seen incredible progress and feel stronger than ever ',
    name: 'JOHN KEVIN',
    status: 'COACH'
  },
  {
    image : image3,
    review:' Amazing atmosphere and professional guidance. This gym truly changed my fitness journey!',
    name: 'FRANKLIN',
    status: "CUSTOMER"
  }
];
